import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { artisanGetProductDetails, artisanProductApprovedAction } from '../../redux/actions/ProductActions';
import NavbarTwo from '../../components/navbar/NavbarTwo';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import Rating from '../../components/Rating';


const ArtisanProductDScreen = ({ artisanProductDetail, artisanGetProductDetails, artisanproductApproved, artisanProductApprovedAction }) => {

    const { id } = useParams()

    const { loading, product, error } = artisanProductDetail;

    const { loading:approvedLoading, success:approvedSuc , error:approvedErr } = artisanproductApproved;

    useEffect(() => {
        artisanGetProductDetails(id)
    }, [artisanGetProductDetails, id, approvedSuc])



    const approvedHandle = (id) => {
        const data = {
            approved: true
        }
        artisanProductApprovedAction(id, data)
        // console.log(id , data);
    }

    const disapprovedHandle = (id) => {
        const data = {
            approved: false
        }
        artisanProductApprovedAction(id, data)
    }



    return (
        <div className='bg-gray-50 min-h-screen sen-font'>
            <NavbarTwo />
            <div className='container max-w-screen-xl mx-auto px-4'>
                <div className='my-10'>
                    <Link to='/admin/artisan/product' className='px-5 py-3 bg-gray-200 hover:bg-gray-300 rounded text-sm font-medium tracking-wider'>GO BACK </Link>
                </div>

                { approvedLoading && <Loader /> }
                { approvedErr && <Message error msg={approvedErr} /> }

                {
                    loading ? <Loader /> : error ? <Message error msg={error} /> : (
                        <div>
                            <div className='text-right my-3'>
                                {
                                    product.approved ?
                                        <button onClick={() => disapprovedHandle(product._id)} className='bg-red-400 md:w-fit w-full text-white p-2.5 rounded uppercase tracking-wide text-sm'>disapproved</button>
                                    :
                                        <button onClick={() => approvedHandle(product._id)} className='bg-green-400 md:w-fit w-full text-black p-2.5 rounded uppercase tracking-wide text-sm'>approved</button>
                                }
                            </div>
                            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-5'>
                                <div>
                                    <img src={product && product.image} alt={product && product.name} className='w-full' />
                                </div>
                                <div>
                                    <div className='mb-1.5'><span className='text-[#8d99ae]'>Name :</span> {product && product.name}</div>
                                    <div className='product__desc sen-font leading-7 md:h-56 md:overflow-auto md:overscroll-auto'>
                                        <span className='text-[#8d99ae]'>Description :</span> {product && product.description}
                                    </div>
                                </div>
                                <div>
                                    <div className='mb-1.5'>
                                        <Rating value={product && product.rating} text={`${product && product.numReviews} reviews`} />
                                    </div>
                                    {/* <div className='mb-1.5'><span className='text-[#8d99ae]'>Brand : </span> { product && product.brand}</div> */}
                                    <div className='mb-1.5'><span className='text-[#8d99ae]'>Category : </span> {product && product.category}</div>
                                    <div className='mb-1.5'><span className='text-[#8d99ae]'>CountInStock : </span> {product && product.countInStock}</div>
                                    <div className='mb-1.5'><span className='text-[#8d99ae]'>Price : </span> {product && product.price}</div>
                                    <div className='mb-1.5'><span className='text-[#8d99ae]'>CreatedAt : </span> {product && product.createdAt}</div>
                                </div>
                                <div>
                                    <h2 className='mb-2 uppercase tracking-wide text-xl'>Creator</h2>
                                    <div className='mb-1.5'>
                                        <span className='text-[#8d99ae]'>Name: </span> {product.user && product.user.name}
                                    </div>
                                    <div className='mb-1.5'>
                                        <span className='text-[#8d99ae]'>Email: </span> {product.user && product.user.email}
                                    </div>
                                    <div className='mb-1.5'>
                                        <span className='text-[#8d99ae]'>Phone: </span> {product.user && product.user.phone}
                                    </div>
                                    <div className='mb-1.5'>
                                        <span className='text-[#8d99ae]'>Role: </span> {product.user && product.user.role}
                                    </div>
                                </div>
                            </div>
                            <div className='pb-6'>
                                <h2 className='my-2 uppercase tracking-wide text-xl'>Review</h2>
                                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4'>
                                    {
                                        product.reviews && product.reviews.map((review) => (
                                            <div key={review._id} className='bg-white p-4 rounded shadow'>
                                                <div className='text-md uppercase tracking-wide'>{review.name}</div>
                                                <Rating value={review.rating} />
                                                <p>{review.comment}</p>
                                                <p className='text-gray-300'>{review.createdAt.substring(0, 10)}</p>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    artisanProductDetail: state.artisanProductDetail,
    artisanproductApproved: state.artisanproductApproved
})

export default connect(mapStateToProps, { artisanGetProductDetails, artisanProductApprovedAction })(ArtisanProductDScreen);